import { render } from "./DanhSachVe.vue?vue&type=template&id=8bbbab3e"
import script from "./DanhSachVe.vue?vue&type=script&lang=js"
export * from "./DanhSachVe.vue?vue&type=script&lang=js"

import "./DanhSachVe.vue?vue&type=style&index=0&id=8bbbab3e&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__